import {
    FETCH_USER_DETAILS_REQUEST,
    FETCH_USER_DETAILS_SUCCESS,
    FETCH_USER_DETAILS_FAILURE
} from '../constants';
import { createReducer } from '../utils/misc';

const initialState = {
    userName: null,
    userEmail: null,
    userPhone: null,
    userTIN: null,
    userRoles: null,
    userAddress: null,
    loadingUser: true,
    id: null,
    changePassword: null,
};

export default createReducer(initialState, {
    [FETCH_USER_DETAILS_REQUEST]: (state) =>
        Object.assign({}, state, {
            loadingUser: true,
        }),
    [FETCH_USER_DETAILS_SUCCESS]: (state, payload) =>
        Object.assign({}, state, {
            userName: payload.username,
            userEmail: payload.email,
            userPhone: payload.phone,
            userTIN: payload.TIN,
            userRoles: payload.roles,
            userAddress: payload.address,
            loadingUser: false,
            id: payload.id,
            changePassword: payload.change_password
        }),
    [FETCH_USER_DETAILS_FAILURE]: (state) =>
        Object.assign({}, state, {
            userName: null,
            userEmail: null,
            userPhone: null,
            userTIN: null,
            userRoles: null,
            userAddress: null,
            loadingUser: false,
            id:null,
            changePassword: null
        }),


});



// WEBPACK FOOTER //
// ./src/reducers/user.js